// TOOD: Add authentication headers to all sent requests
const request = async (url, options) => fetch(
	url,
	{
		headers: {"Content-Type": "application/json"},
		...options,
	},
).then(res => {
	if (res.status < 300) {
		try {
			return res.json()
		} catch (e) {
			try {
				return res.body()
			} catch (e2) {
				throw e2
			}
		}
	} else {return {status: res.status}}
})
	.catch(console.error)

const qs = (obj = {}) => new URLSearchParams(obj).toString()
export const get = (url, body = {}, options = {}) => request(`${url}${body ? `?${qs(body)}` : ""}`, {...options, method: "GET"})
export const post = (url, body = {}, options = {}) => request(url, {...options, body: JSON.stringify(body), method: "POST"})
export const put = (url, body = {}, options = {}) => request(url, {...options, body: JSON.stringify(body), method: "PUT"})
export const del = (url, body = {}, options = {}) => request(url, {...options, body: JSON.stringify(body), method: "DELETE"})
// TODO: Add PATCH and DELETE handlers
